<template>

    <div class="SC-split__col" v-if="matches.length > 0">

        <div class="Results-matches">

            <score-card v-for="match in matches"
                        :match="match"
                        v-if="showMatch(match)"
                        :flagPath="flagPath"
                        :key="match.id"
                        mode="result"
                        :type="type"
                        :detail="detail"
                        :data-id="match.id">
            </score-card>

        </div>

        <!-- <div class="na">
            <div class="na__info" v-html="ico_info"></div>

            <div class="na__title" style="margin-bottom: 0">
                No results for this round
            </div>
        </div> -->

            <a class="general-button blue-background generic-medium" :href="results">View {{this.type}} results</a>

    </div>

</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import MatchCard from './MatchCard.vue'

    export default {
        components: {
            'score-card': MatchCard,
        },
        props: ['type', 'flag', 'detail', 'results', 'tournament'],
        data() {
            return {
                feed            : [],
                matches         : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                tournament_slug : this.tournament,
            }
        },
        created() {
            axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/draws`).then(response => {

                this.feed = response.data

                let allMatches = this.getAllMatchesInOneArray(response.data)



                let finishedMatches = this.getOnlyFinishedMatches(allMatches)

                let app = this

                finishedMatches.sort( function(a, b) {

                    let dateFormat;
                        dateFormat = 'YYYY-MM-DDTHH'
                    let matchDateA = moment().format(a.detail.ts,dateFormat)
                    let matchDateB = moment().format(b.detail.ts, dateFormat)

                    if ( moment( matchDateA ).isAfter( matchDateB ) )

                        return -1
                    else if ( moment( matchDateA ).isBefore( matchDateB ) )
                        return 1
                    else if ( moment( matchDateA ).isSame( matchDateB ) )
                        return 0

                })

                //show only the last 4 matches
                finishedMatches.splice(3);

                this.matches = finishedMatches

            }).catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            // getLatestMatch(type, matches) {
            //     let latestMatchId = '';
            //     let latestMatch = [];
            //     let latestDate = '';
            //     let dateFormat;
            //
            //     let today = moment().tz('America/Chicago').startOf('day').format()
            //
            //     if ( type == 'atp' )
            //         dateFormat = 'MMM D YYYY  h:mmA'
            //     else if ( type == 'wta' )
            //         dateFormat = 'YYYY-MM-DDTHH:mm:ss'
            //
            //     matches.filter( function(match) {
            //
            //         let matchDate = moment( match.detail.ts, dateFormat ).format()
            //
            //         if ( latestDate == '' )
            //             latestDate = matchDate
            //
            //         if ( moment( matchDate ).isSameOrAfter( latestDate ) ) {
            //             latestDate = matchDate
            //
            //             latestMatchId = match.id
            //
            //         }
            //     })
            //
            //     if ( latestMatchId != '' ) {
            //         matches.filter( function(match) {
            //             if ( match.id == latestMatchId ) {
            //                 latestMatch.push(match)
            //             }
            //         })
            //     }
            //
            //     return latestMatch;
            // },
            getOnlyFinishedMatches(matches) {
                return matches.filter(function(match) {

                    return match.detail.state == 'F'

                })

            },
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            }
        }

    }
</script>
